import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { RoleMgr, ShowRequest } from '../../../../core';
import { ScoutPath, ScoutPoint, TaskStatus } from '../../../../core/models';
import { ScoutTaskDoc } from '../../../../core/schema/scout-task-schema';
import { ScoutTaskService } from '../../../../core/services';
import { ScoutPointRefDialogComponent } from '../../../scout-point/scout-point-ref-dialog/scout-point-ref-dialog.component';

@Component({
  selector: 'app-path-point-parameters-table',
  templateUrl: './path-point-parameters-table.component.html',
  styleUrls: ['./path-point-parameters-table.component.scss',
    '../../../../shared/components/table-view/scss/table-view.scss',
  ]
})
export class PathPointParametersTableComponent implements OnInit, OnDestroy {

  @Input() scoutTask : ScoutTaskDoc
  @Input() scoutPathIds : string[] = []
  @Input() tableClasses : string[] = ['table-striped']
  @Input('detailFn') detailFn : (vi: ShowRequest) => void
  
  columnNames : string[] = [ 'From', 'To', 'Test Point ID', 'Type', 
    'Latitude', 'Longitude',
    'HAE', 'Approx Horiz Error', 'Approx Vert Error',  
    'Nearest Window (meters)', 'Windows Within 7.62m', 'Wall Ref 1', 'Wall Ref 2',
    'Floor To Ceiling (meters)', 'Building Quadrant', 'Clutter Description',
    'HVAC Environment', 'Point Description'
  ]

  scoutPaths : ScoutPath[] = []
  
  constructor(
      public scoutTaskService: ScoutTaskService,
      public roleMgr: RoleMgr,
      public bsModalService: BsModalService){
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.scoutPathsSubscription?.unsubscribe()
  }

  scoutPathsSubscription : Subscription
  
  populate(pathIds:string[]=null) {
    this.scoutPathsSubscription?.unsubscribe()
    if ( pathIds ) {
      this.scoutPathIds = pathIds
    }
    this.scoutPathsSubscription = this.scoutTask.get$('scoutPaths').subscribe( scoutPaths => {
      this.scoutPaths = scoutPaths.filter(sp=>this.scoutPathIds.includes(sp.id))
      this.scoutPaths.forEach(sp=>this.scoutTaskService.updateScoutPathContext(sp,[]))
      //console.log( JSON.stringify(this.scoutPaths.map(sp=>({id:sp.id,index:(sp as any).index}))))
    })
  }

  showScoutPoint( scoutPath: ScoutPath, scoutPoint: ScoutPoint ) {
    let uiLocked = TaskStatus.uiLockHandler(scoutPath.statusId, this.roleMgr.canEditUsers)
    const context : ModalOptions = {
      initialState: {
        scoutPointId: scoutPoint.id,
        scoutPathId: scoutPath.id,
        scoutTaskDoc: this.scoutTask,
        allowEditMode: true,
        locked: uiLocked,
        hidePhotos: true
      },
      class: 'full-screen-modal',
      id: ScoutPointRefDialogComponent.ModalId,
      animated: true,      
      ignoreBackdropClick: true    
    } 
    const modalRef = this.bsModalService.show(ScoutPointRefDialogComponent, context );
  }

  showScoutPath( scoutPath: ScoutPath ) {
    this.detailFn( new ShowRequest('tab','scout path',scoutPath.id,this.scoutTask) )
  }  
}
